<template>
    <div class="popular">
        <header class="popular-panel__header h5">Populaire zoekopdrachten</header>

        <div class="popular-panel__queries">
            <div class="query-list">
                <button
                    v-for="(item, index) in items"
                    :key="`${item}-${index}`"
                    class="query-list__item"
                    @click="$emit('update', item)"
                    type="button">
                    {{ item }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    items: string[];
}>();
</script>
